import {  DataFromUrl, EditJob, handleOtherResponseCode, InterviewStage, REDIRECT, 
          startDateMessage, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, 
          CustomToastrAction} from  '@/imports-files/pages/clients/jobs/interview-stages';

export function setToastrMessage(jobStages){
  let message = ""
  jobStages?.map((stage, index) => {
    if(jobStages[index].member_emails){
    if(message.length > 0) { message += " </br> "}
    message += `${jobStages[index].member_emails}`
    }
  })
  return message;
}


export async function handleFormSubmit(values, router, setPageName, queryClient, fromKanban, gotoKanban, setDisabledSaveButton)
{ 
    setDisabledSaveButton(true);
  let job_stages_attributes   =   values.job.job_stages_attributes
  let order                   =   2;
  job_stages_attributes       =   job_stages_attributes.map((x, index) => {
                                                                              delete x["stage_emails"]; 
                                                                              if(!x._destroy){
                                                                                x["order"] = order
                                                                                order = order + 1

                                                                                if(x.placeholder && x.placeholder.length > 0){
                                                                                  if(x.job_stage_label_attributes.label.length > 0){
                                                                                    x.job_stage_label_attributes.label = x.job_stage_label_attributes.label
                                                                                  }
                                                                                  else{
                                                                                    x.job_stage_label_attributes.label = x.placeholder
                                                                                  }
                                                                                }
                                                                              }
                                                                              return x 
                                                                          })

  values.job.job_stages_attributes  =  job_stages_attributes
  const result                      =  await new InterviewStage().addJobStages(values);
  const status_code                 =  result.status || result.response.status;
  const customToastrAction          =  new CustomToastrAction();

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    let queryPath = fromKanban ? "?from_kanban=true" : ""
    if(gotoKanban){
      if(fromKanban){
        router.push({pathname: REDIRECT.client.kanban_board.replace('$job_id', response.id)});
      }
      else{
        router.push({ pathname: REDIRECT.client.jobs.index, query: { job_type: 'active' } });
      }
    }
    else
      router.push(REDIRECT.client.jobs.interview_details.replace('$job_id', response.id)+queryPath);
    break;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    let message = setToastrMessage(result.response.data.error.job?.job_stages_attributes)
    if(result.response.data.error.job?.base) { message = startDateMessage(message, result.response.data.error.job?.base)}
    if(message.length > 0)
    {
      customToastrAction.setNormalToastr(message, 'warning');
    }
    setDisabledSaveButton(false);
    return result.response.data.error  
  default: 
      handleOtherResponseCode(status_code, router);
      setDisabledSaveButton(false);
  }
}


export async function getClientUsers(name_or_email, step, router)
{
  const body                =   {name_or_email: name_or_email, step: step}
  const result              =   await new InterviewStage().getUserByNameOrEmail(body);
  const status_code         =   result.status || result.response.status;
  const customToastrAction  =   new CustomToastrAction(); 

  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    return response.users
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    customToastrAction.setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
    return []
  default: 
    handleOtherResponseCode(status_code, router);
  }
}


export async function getInterviewStagesData(setApiError)
{
  // var job_id          =   window.location.pathname.split('/').slice(-2)[0];
  var job_id          =  new DataFromUrl().getJobId();
  const result        =  await new InterviewStage().getInteviewStageData(job_id);
  const job_result    =  await new EditJob().getJobInfo(job_id);
  if(result.request.status == 200){
   const job           =  job_result.data.job
   const data          =  {
                              props: {
                                        result: result.data,
                                        job: job
                                     }
                           }
    return data;
  }
  else{
    setApiError(result.request)
  }
}

export function onDragEnd(result, formRef, setDirtyArray){
  const { destination, source } = result;
  if (!destination) {
    return;
  }

  if (
    destination.droppableId === source.droppableId &&
    destination.index === source.index
  ) {
    return;
  }
  setDirtyArray(true)
  let add;
  let active = formRef.current.values.job.job_stages_attributes;
  // Source Logic
  if (destination.droppableId === "InterviewsList" || destination.droppableId === "ScreeningList" ) {
    add = active[source.index];
    active.splice(source.index, 1);
  } 

  // Destination Logic
  if (destination.droppableId === "InterviewsList" || destination.droppableId === "ScreeningList" ) {
    active.splice(destination.index, 0, add);
  } 
  formRef.current.setFieldValue('job.job_stages_attributes', [...active])
}

